import { listenToAssetStatuses, type AssetStatusItem } from 'packages/services/assetsService';
import type { SseSubscribeOptions } from '../useSseSubscribe';

type Params = {
    assetIds: string[];
    onMessage: SseSubscribeOptions<{ items: AssetStatusItem[] }>['onMessage'];
};

export function sseAssetsStatusOptions({
    assetIds,
    onMessage,
}: Params): SseSubscribeOptions<{ items: AssetStatusItem[] }> {
    return {
        deps: assetIds,
        // The `{ items }` re-wrap keeps the consumer's onMessage signature identical across both
        // transports.
        subscribe: (onData, onClose) => listenToAssetStatuses(assetIds, (items) => onData({ items }), onClose),
        onMessage,
    };
}
